import { createSlice } from '@reduxjs/toolkit';
import { QUESTION_BANK_REVIEW } from '../../actions/QuestionBankReview/actionTypes';

const initialState = {
  questionBankReview: {
    isLoading: false,
    questionBankQBR: [],
    questionBankQBRReview: [],
    Suggestion: [],
    QuestionIndexData: [],
    QuestionPreviewDetails: [],
    SaveReview: {
      SaveQuestionReview: [],
      errors: '',
      message: '',
      isLoading: false
    },
    EditReview: [],
    errors: '',
    message: ''
  }
};

export const questionBankReviewSlice = createSlice({
  name: QUESTION_BANK_REVIEW,
  initialState,
  reducers: {
    getQuestionBankReviewAction: (state) => {
      state.questionBankReview.isLoading = true;
      state.questionBankReview.errors = '';
      state.questionBankReview.message = '';
      state.questionBankReview.questionBankQBR = [];
    },
    getQuestionBankReviewSuccessAction: (state, action) => {
      if (action.payload) {
        state.questionBankReview.message = '';
        state.questionBankReview.questionBankQBR = [];
        state.questionBankReview.questionBankQBR = action.payload;
      }
      state.questionBankReview.isLoading = false;
    },
    getQuestionBankReviewFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },

    getQuestionQBRAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.questionBankQBRReview = [];
      state.questionBankReview.isLoading = true;
      state.questionBankReview.errors = '';
    },
    getQuestionQBRSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      if (action.payload) {
        state.questionBankReview.questionBankQBRReview = [];
        state.questionBankReview.questionBankQBRReview = action.payload;
      }
      state.questionBankReview.isLoading = false;
    },
    getQuestionQBRFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },

    setQuestionReviewBankAction: (state) => {
      state.questionBankReview.isLoading = true;
      state.questionBankReview.errors = '';
      state.questionBankReview.message = '';
    },
    setQuestionReviewBankSuccessAction: (state, action) => {
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = '';
      state.questionBankReview.message = '';
      // state.questionBankReview.message = action.payload;
      if (action.payload === true) {
        state.questionBankReview.message = '';
        state.questionBankReview.message = 'Saved Successfully!';
      } else {
        state.questionBankReview.errors = 'Cannot save. Question already exists!';
      }
    },
    setQuestionReviewBankFailureAction: (state, action) => {
      state.questionBankReview.errors = '';
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },
    setQuestionSuggestionAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = true;
      state.questionBankReview.Suggestion = [];
      state.questionBankReview.errors = '';
    },
    setQuestionSuggestionSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      if (action.payload) {
        state.questionBankReview.Suggestion = [];
        state.questionBankReview.Suggestion = JSON.parse(action.payload);
      }
      state.questionBankReview.isLoading = false;
    },
    setQuestionSuggestionFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },

    GetCurrentAndPreviousQuestionAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = true;
      state.questionBankReview.QuestionIndexData = [];
      state.questionBankReview.errors = '';
    },
    GetCurrentAndPreviousQuestionSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      const raw = action.payload;
      let parsed = raw;
      if (raw != null && typeof raw === 'string') {
        try {
          parsed = JSON.parse(raw);
        } catch {
          parsed = {};
        }
      }
      state.questionBankReview.QuestionIndexData =
        parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      state.questionBankReview.isLoading = false;
    },
    GetCurrentAndPreviousQuestionFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },

    GetQuestionDetailsForPreviewAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = true;
      state.questionBankReview.QuestionPreviewDetails = [];
      state.questionBankReview.errors = '';
    },
    GetQuestionDetailsForPreviewSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      if (action.payload) {
        state.questionBankReview.QuestionPreviewDetails = [];
        state.questionBankReview.QuestionPreviewDetails = action.payload;
      }
      state.questionBankReview.isLoading = false;
    },
    GetQuestionDetailsForPreviewFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = false;
      state.questionBankReview.errors = action.payload;
    },

    SaveQuestionReviewAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.SaveReview.isLoading = true;
      state.questionBankReview.SaveReview.SaveQuestionReview = [];
      state.questionBankReview.SaveReview.errors = '';
    },
    SaveQuestionReviewActionSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      if (action.payload) {
        state.questionBankReview.SaveReview.SaveQuestionReview = action.payload;
      }
      state.questionBankReview.SaveReview.isLoading = false;
    },
    SaveQuestionReviewActionFailureAction: (state, action) => {
      state.questionBankReview.message = '';
      state.questionBankReview.SaveReview.isLoading = false;
      state.questionBankReview.SaveReview.errors = action.payload;
    },

    EditQuestionReviewAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.isLoading = true;
      state.questionBankReview.EditReview = [];
      state.questionBankReview.errors = '';
    },
    EditQuestionReviewActionSuccessAction: (state, action) => {
      state.questionBankReview.message = '';
      if (action.payload) {
        state.questionBankReview.EditReview = action.payload;
      }
      state.questionBankReview.isLoading = false;
    },
    SaveQuestionReviewActionFailureAction: (state, action) => {
      state.questionBankReview.isLoading = false;
      state.questionBankReview.message = '';
      state.questionBankReview.errors = action.payload;
    },
    resetQuestionReviewBankAction: (state) => {
      state.questionBankReview.message = '';
      state.questionBankReview.errors = '';
    }
  }
});

export const {
  getQuestionBankReviewAction,
  getQuestionBankReviewSuccessAction,
  getQuestionBankReviewFailureAction,
  getQuestionQBRAction,
  getQuestionQBRSuccessAction,
  getQuestionQBRFailureAction,
  setQuestionReviewBankAction,
  setQuestionReviewBankSuccessAction,
  setQuestionReviewBankFailureAction,
  setQuestionSuggestionAction,
  setQuestionSuggestionSuccessAction,
  setQuestionSuggestionFailureAction,
  GetCurrentAndPreviousQuestionAction,
  GetCurrentAndPreviousQuestionSuccessAction,
  GetCurrentAndPreviousQuestionFailureAction,
  GetQuestionDetailsForPreviewAction,
  GetQuestionDetailsForPreviewSuccessAction,
  GetQuestionDetailsForPreviewFailureAction,
  SaveQuestionReviewAction,
  SaveQuestionReviewActionSuccessAction,
  SaveQuestionReviewActionFailureAction,

  EditQuestionReviewAction,
  EditQuestionReviewActionSuccessAction,
  EditQuestionReviewActionFailureAction,
  resetQuestionReviewBankAction
} = questionBankReviewSlice.actions;

export default questionBankReviewSlice.reducer;
